import { IImageStyles } from '@fluentui/react';

export const imageStylesDefault: Partial<IImageStyles> = {};

export const imageStylesSingle: Partial<IImageStyles> = {
  root: {
    height: '100%',
    width: '100%',
  },
  image: {
    width: '100%',
  },
};

export const imageStylesCarousel: Partial<IImageStyles> = {
  root: {
    height: '100%',
    width: '100%',
  },
  image: {
    width: 'auto',
  },
};

export const imageStylesLogo: Partial<IImageStyles> = {
  image: {
    height: 80,
    width: 'auto',
  },
};
